import Typography from '@repo/ui/typography'
import { useEffect } from 'react'

import withTheme from '../../components/hoc/with-theme'
import AuthLayout from '../../components/layouts/auth-layout'
import { LoginForm } from '../../components/pages/login/login-form'

export const LoginPage = () => {
  useEffect(() => {
    document.querySelector('html')?.setAttribute('data-theme', 'admin')
  }, [])

  return (
    <AuthLayout text="Bienvenue à nouveau!">
      <Typography variant="h1" className="mb-6">
        Se connecter
      </Typography>
      <LoginForm />
    </AuthLayout>
  )
}

export default withTheme(LoginPage, 'admin')
